let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("buA4m")).then(() => parcelRequire('65pkJ'));